/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as moment from 'moment';
import { bindActionCreators } from 'redux';
/* Package JSON Import will be here */

/* Project Import will be here */
import ForecastComponent from './forcast.Component';
import { ApiUrls } from '../../services/api';
import Api from '../../services/api/serviceCall';
import { Constants } from '../../config/appConstants';
import { MessageBox } from '../sharedComponent/messageBox';
import * as actions from '../../actions/login.Action';
/* Project Import will be here */

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class Forecast extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                activePage: 1,
                totalCount: 0,
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE
            },
            isOpenModel: false,
            forecastDataList: [],
            selectedValue: {
                forecastDate: null,
                forecastDays: 0,
                previousForecastDate: null
            },
            isEditForecast: false,
            isSetButtonDisabled: false,
            isSetButtonConfirm: false
        };
    }

    componentDidMount() {
        this.getForecastList();
    }

    getForecastDetails(forecastId) {
        let { selectedValue } = this.state;
        let url = `${ApiUrls.Routes.FOREC_C}${ApiUrls.Routes.GT_FOREC_M}?forecastId=${forecastId}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    if (responseData.data.forecast[0].forecastDate) {
                        selectedValue.forecastDate = moment(responseData.data.forecast[0].forecastDate).format("MM/DD/YYYY");
                        selectedValue.previousForecastDate = moment(responseData.data.forecast[0].forecastDate).format("MM/DD/YYYY");
                    } else {
                        selectedValue.forecastDate = "";
                        selectedValue.previousForecastDate = "";
                    }
                    selectedValue.forecastDays = (responseData.data.forecast[0].forecastDays != null) ? responseData.data.forecast[0].forecastDays : 0;
                    selectedValue.id = responseData.data.forecast[0].id;
                    this.setState({
                        selectedValue, isEditForecast: true
                    });
                }
                else {
                    this.setState({
                        selectedValue: {}, isEditForecast: false
                    });
                }
            }
        });
    }

    getForecastList() {
        let { pagination } = this.state;
        let requestData = {
            Skip: pagination.skip,
            Take: pagination.take
        }
        let url = `${ApiUrls.Routes.FOREC_C}${ApiUrls.Routes.GT_FOREC_LT_M}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    pagination.totalCount = Math.ceil(responseData.totalCount / Constants.DEFAULT_TAKE);
                    var currentDate = moment(new Date());
                    responseData.data.forEach(a => {
                        const forecastdate = new Date(a.forecastDate);
                        a['isPastDate'] = moment(forecastdate) < currentDate;
                    });
                    this.setState({
                        forecastDataList: responseData.data,
                        pagination
                    });
                }
                else {
                    this.setState({
                        forecastDataList: []
                    });
                }
            }
        });
    }

    onPageChange = (e, { activePage }) => {
        let { pagination } = this.state;
        pagination.skip = ((activePage - 1) * Constants.DEFAULT_TAKE) + 1;
        pagination.take = ((activePage - 1) * Constants.DEFAULT_TAKE) + Constants.DEFAULT_TAKE;
        pagination.activePage = activePage;
        this.setState({
            pagination
        }, () => {
            this.getForecastList();
        });
    }

    onOpenModel = forecastDetails => {
        if (forecastDetails.forecastId) {
            this.getForecastDetails(forecastDetails.forecastId);
        }
        this.setState({
            isOpenModel: true,
            selectedValue: {
                forecastDate: null,
                forecastDays: 0,
                previousForecastDate: null
            }
        });
    }

    onCloseModel = () => {
        this.setState({
            isOpenModel: false, isEditForecast: false, selectedValue: { forecastDate: null, forecastDays: 0, previousForecastDate: null }
        }, () => this.getForecastList());
    }

    deleteForecast = forecast => {
        let { selectedValue } = this.state;
        if (forecast) {
            selectedValue.id = forecast.id;
            this.setState({
                selectedValue,
                isSetButtonConfirm: true
            });
        }
    }

    onCancelConfirm() {
        this.setState({ isSetButtonConfirm: false })
    }

    handleDateChange(date) {
        let { selectedValue } = this.state;
        if ((new Date(date) !== "Invalid Date") && !isNaN(new Date(date))) {
            var dateString = date.toLocaleDateString("en-US");
            var splitDate = dateString.split(" ")[0];
            selectedValue.forecastDate = moment(splitDate).format("MM/DD/YYYY");
            this.setState({
                selectedValue
            });
        }
    }

    //handleForecastDaysChange = (e, { value }) => {
    //    let { selectedValue } = this.state;
    //    if (value.charAt(0) != " ") {
    //        selectedValue.forecastDays = parseInt(value);
    //    }
    //    this.setState({ selectedValue });
    //}

    onSaveForecast(forecastId = null) {
        let { selectedValue, isEditForecast } = this.state;
        this.setState({ isSetButtonDisabled: true });
        if (!selectedValue.forecastDate) {
            MessageBox(Constants.PLEASE_ENTER_FORECAST_DATE, Constants.ERROR);
            this.setState({ isSetButtonDisabled: false });
            return;
        }
        //if (!selectedValue.forecastDays || selectedValue.forecastDays === 0) {
        //    MessageBox(Constants.PLEASE_ENTER_FORECAST_DAYS, Constants.ERROR);
        //    this.setState({ isSetButtonDisabled: false });
        //    return;
        //}

        if (forecastId != null) {
            selectedValue.id = forecastId;
            isEditForecast = false;
        }
        selectedValue.UserId = this.props.user.userId;
        let url = `${ApiUrls.Routes.FOREC_C}${ApiUrls.Routes.SV_FOREC_M}`;
        Api.Post(url, selectedValue, this).then((responseData) => {
            if (responseData && forecastId == null) {
                MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                if (!responseData.success) {
                    this.setState({ isSetButtonDisabled: false });
                }
            }
            else if (responseData && forecastId != null && responseData.success) {
                MessageBox(Constants.UPDATED_SUCCESSFULLY, Constants.SUCCESS);
                this.setState({ isSetButtonDisabled: false });
            }
            else {
                MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                this.setState({ isSetButtonDisabled: false });
            }
            if (responseData.success) {
                this.onCloseModel();
                this.setState({ isSetButtonConfirm: false, isSetButtonDisabled: false });
            }
        });
    }

    onDeleteForecast() {
        let { selectedValue } = this.state;
        selectedValue.UserId = this.props.user.userId;
        this.setState({ isSetButtonConfirm: true });
        let url = `${ApiUrls.Routes.FOREC_C}${ApiUrls.Routes.DL_FOREC_M}`;
        Api.Post(url, selectedValue, this).then((responseData) => {
            if (responseData) {
                MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                if (responseData.success) {
                    this.onCancelConfirm();
                }
                this.setState({
                    isSetButtonConfirm: false, selectedValue: { id: 0 }
                }, () => this.getForecastList());
            }
        });
    }

    render() {
        const { pagination, isOpenModel, forecastDataList, selectedValue, isEditForecast, isSetButtonDisabled, isSetButtonConfirm } = this.state;
        return (
            <Fragment>
                <ForecastComponent
                    {...{
                        forecastPage: {
                            pagination,
                            isOpenModel,
                            forecastDataList,
                            selectedValue,
                            isEditForecast,
                            isSetButtonDisabled,
                            isSetButtonConfirm
                        }
                    }}
                    onPageChange={this.onPageChange.bind(this)}
                    user={this.props.user}
                    onOpenModel={this.onOpenModel.bind(this)}
                    onCloseModel={this.onCloseModel.bind(this)}
                    onCancelConfirm={this.onCancelConfirm.bind(this)}
                    onSaveForecast={this.onSaveForecast.bind(this)}
                    onDeleteForecast={this.onDeleteForecast.bind(this)}
                    handleDateChange={this.handleDateChange.bind(this)}
                    deleteForecast={this.deleteForecast.bind(this)}
                //handleForecastDaysChange={this.handleForecastDaysChange.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions),
        dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Forecast));

Forecast.displayName = 'Forecast';